<app-button [text]="text" (onClick)="clicked($event)"></app-button>